import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const StyledNavLink = styled(NavLink)`
	text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
	color: inherit;
	display: ${({ inline }) => (inline ? 'inline !important' : 'inline-block')};
	width: fit-content;
`;
